import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Home } from 'lucide-react';
import { notFoundStyles } from './NotFound.styles';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
    const { t } = useTranslation();
    return (
        <Box sx={notFoundStyles.root}>
            <Typography variant="h1" fontWeight={800} color="primary.main" sx={notFoundStyles.title}>
                404
            </Typography>
            <Typography variant="h5" fontWeight={600} mt={2} mb={1}>
                {t('notFound.title')}
            </Typography>
            <Typography color="text.secondary" mb={4} maxWidth={400}>
                {t('notFound.description')}
            </Typography>
            <Button variant="contained" startIcon={<Home size={20} />} component={Link} to="/" size="large">
                {t('notFound.backHome')}
            </Button>
        </Box>
    );
};

export default NotFound;
